import Vue from 'vue'
import Vuex from 'vuex'
import store from '@/store'
import cachedViews from './modules/cachedViews'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userID: '',
    cardRefresh: false,
    iovoiceRefresh:false,
    Statusheight: 0,
    // token:'eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyIjoie1wibG9naW5UaW1lXCI6MTY1OTU4MDg0OTc1MSxcInVzZXJDb2RlXCI6XCI1NzQ1ODkyODk4Mzc1NzIwOTZcIn0ifQ.SX7uV4wrwcQrFiLetTnN8Xy6hOenFToF_mMrtVoRYqQ',
    // opsToken: 'eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyIjoie1widGhpcmRDb21wYW55SWRcIjoxODk1ODc2NDQ0NTIxLFwidXNlcklkXCI6NDgwNzYwMjU5NjM0ODk2NDg2NH0ifQ.UU5Rf1H0bzK1ncpa27olh52cY3nkrV2qAHvGYqqtjTc',
    // token: 'eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyIjoie1wibG9naW5UaW1lXCI6MTY1OTA3MjM1NDQ2MixcInVzZXJDb2RlXCI6XCI1NzQ1ODgxMDAxNTI2MDI2MjRcIn0ifQ.i8tTTwadn8m8YZ2kiEIF4tvILRD8__C6PCpnUWYwJhk',
    opsToken: '',
    token:''
  },
  mutations: {
    UpdateStatusheight(state, data) {
      state.Statusheight = data || 0
    },
    UpdateUserInfo(state, data) {
      state.token = data.token
      state.opsToken = data.opsToken
      state.userID = data.userID
      localStorage.setItem("token", data.token);
      localStorage.setItem("opsToken", data.opsToken);
    },
    // 用于兑换卡券成功后返回刷新列表
    UpdatecardRefresh(state, data) {
      state.cardRefresh = data
    },
    UpdateiovoiceRefresh(state, data) {
      state.iovoiceRefresh = data
    }
  },
  actions: {
    Login(context, info) {
      store.commit('UpdateUserInfo', info)
    }
  },
  modules: {
    cachedViews
  },
  getters: {
    GetStatus: state => {
      return state.Statusheight < 35 ? state.Statusheight : 30
    },
    opsIsLogin: state => {
      return state.opsToken && state.opsToken.length > 0
    },
    omsIsLogin: state => {
      return state.token && state.token.length > 0
    }
  }
})
